import { render, staticRenderFns } from "./xuankezhiyuan.vue?vue&type=template&id=0e794f62&scoped=true"
import script from "./xuankezhiyuan.vue?vue&type=script&lang=js"
export * from "./xuankezhiyuan.vue?vue&type=script&lang=js"
import style0 from "./xuankezhiyuan.vue?vue&type=style&index=0&id=0e794f62&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e794f62",
  null
  
)

export default component.exports